<!--

This file is copied and modified FinalPreview from the test folder as the
component needs modifications. I did not wanna break the one in the post
creation flow. However it should be abstractde and merged asap.
So I suggest creating a wrapper for the post creation flow for this component.

-->

<script lang="ts">
  // Garden Common Types & enums
  import type { IDetails, WithCreatorData } from 'garden-common';
  import type { FPost } from 'garden-common';
  import { VideoExts } from 'garden-common/index';
  // Third party
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  // Svelte
  import { fly } from 'svelte/transition';
  import { goto } from '$app/navigation';
  import { createEventDispatcher, onMount } from 'svelte';
  // Stores
  import { me } from '$stores/user.store';
  import { isMobile } from '$src/stores/media.store';
  // Components
  import ImageCarousel from '$lib/components/common/image/ImageCarousel.svelte';
  import TaggingOverlay from '$lib/components/common/tagging/TaggingOverlay.svelte';
  import UserWrapper from '../../common/user/userWrapper.svelte';
  import Button from '../../common/buttons/Button.svelte';
  import ThreeDotMenu from '../../posts/ThreeDotMenu.svelte';
  import Collaborators from '../Collaborators.svelte';
  import Tag from '../../common/tagging/Tag.svelte';
  // Tabs
  import Seed from './tabs/Seed.svelte';
  import Details from './tabs/Details.svelte';
  import Workflow from './tabs/Workflow.svelte';
  import Comments from './tabs/Comments.svelte';
  import Taggings from './tabs/Taggings.svelte';
  import ArtistDetails from './tabs/ArtistDetails.svelte';
  import UnderlinedTabs from '$lib/components/posts/UnderlinedTabs.svelte';
  // Icons
  import PostHeart from '$icons/PostHeartIcon.svelte';
  import PostFolder from '$icons/PostFolderIcon.svelte';
  // Modals
  import SaveToGallery from '../../Modals/gallery/SaveToGallery.svelte';
  import CreateGallery from '../../Modals/gallery/CreateGallery.svelte';
  import AddToGallery from '../../Modals/gallery/AddToGallery.svelte';
  import DonateModal from '../../CreatePost/DonateModal.svelte';
  import DeletePostModal from '../../CreatePost/DeletePostModal.svelte';
  // Utils
  import { isMediaType } from 'garden-utils/index';
  import { PostsCore } from '$src/utils/postsCore.util';
  // Media Viewers
  import Media from '../../common/media/Media.svelte';
  import MobileImageCarousel2 from '$lib/components/CreatePost/MobileImageCarousel2.svelte';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;

  let threeDotIgnoredTargets = [];
  const core = new PostsCore($me, post);
  const dispatch = createEventDispatcher();

  export let disableMediaSelectHoverBg = false;
  export let selectedMediaIndex = 0;
  export let disableBorder = false;
  export let preview: boolean = false;
  export let groupIndex = 0;
  export let uploadable: boolean = true;
  export let hideTabs: string[] = [];
  export let activeTab = 'Details';

  dayjs.extend(relativeTime);

  let mediaDetails: IDetails<string> = null;

  const updateMediaProps = (): string => {
    if (media) {
      const selectedMedia = media[selectedMediaIndex];
      const mediaUrl = selectedMedia.images[groupIndex] as any;
      srcImg = mediaUrl;
      const thumbnail = selectedMedia.thumbnails[groupIndex];
      const mediaUrlType = typeof mediaUrl;
      const isNormal = selectedMedia.images && mediaUrlType === 'string';
      let isImage = !isMediaType(mediaUrl, VideoExts, post.wasItem) && isNormal;
      let isVid = isMediaType(mediaUrl, VideoExts, post.wasItem) && isNormal;
      const isBlob = selectedMedia.thumbnails && thumbnail instanceof Blob;

      if (isBlob) {
        // const videoblob = thumbnail.type.split('/')[0] == 'video';
        const blobURL = URL.createObjectURL(thumbnail as Blob);
        return blobURL;
      } else if (isImage) {
        // Display an image
        return mediaUrl;
      } else if (isVid) {
        // Display a video
        return mediaUrl;
      } else {
        // Handle unsupported media type or missing data
        console.error('Unsupported media type or missing data');
        return '';
      }
    }
  };

  const getCategories = () => {
    if (!post?.subcategories) return [];
    if (post?.subcategories.length > 2) {
      return [
        post.category,
        ...post?.subcategories,
        '+' + (post?.subcategories.length - 2).toString()
      ];
    }
    return [post.category, ...post.subcategories];
  };

  const setPost = async () => {
    post = core.getPost();
  };


  let tabs: UnderlinedTab.Item[] = [];

  if (!post.artistsDetails) {
    hideTabs.push('About Artist');
  }

  $: title = post?.title;
  $: description = post?.description;
  $: media = post?.media; // Blobs images are string id's
  $: workflow = null;
  $: srcImg = '';

  $: if (post.media && post.media.length > 0 && post.media[selectedMediaIndex]) {
    mediaDetails = post?.media[selectedMediaIndex]?.details?.details || {};
    workflow = post?.media[selectedMediaIndex]?.workflow;
  }
  $: if ((selectedMediaIndex, groupIndex)) srcImg = updateMediaProps();
  $: categories = getCategories();

  $: tabs = [
    {
      title: 'About Artist',
      badge: 0,
      content: {
        component: ArtistDetails,
        props: { post }
      }
    },
    {
      title: 'Details',
      badge: mediaDetails ? Object.keys(mediaDetails)?.length + 1 : undefined,
      content: {
        component: Details,
        props: { post, selectedMediaIndex, mediaDetails }
      }
    },
    {
      title: 'Workflow',
      badge:
        post?.media[selectedMediaIndex]?.workflow[0]?.title?.length == 0
          ? 0
          : post?.media[selectedMediaIndex]?.workflow.length,
      content: {
        component: Workflow,
        props: { workflow, userName: post.creatorData.name }
      }
    },
    {
      title: 'Tags',
      badge: post?.tags?.length || 0,
      content: {
        component: Taggings,
        props: { post }
      }
    },
    {
      title: 'Comments',
      badge: post?.comments?.length || 0,
      content: {
        component: Comments,
        props: { post, core }
      }
    },
    {
      title: 'Seeds',
      badge: undefined,
      content: {
        component: Seed,
        props: { post }
      }
    }
  ].filter(tab => !hideTabs.includes(tab.title));

  onMount(() => {
    if (media && media.length > 0) {
      updateMediaProps();
    }
  });
</script>

{#if core.openModal === 'save-to-gallery'}
  <SaveToGallery
    postId={post?._id}
    on:ModalClose={() => (core.openModal = null)}
    on:Saved={() => {
      core.SavePostToGallery();
      setPost();
    }}
    on:OpenCreateGallery={() => {
      core.OpenCreateGallery();
      setPost();
    }}
  />
{:else if core.openModal === 'create-gallery'}
  <CreateGallery
    {post}
    on:GalleryCreated={() => {
      core.openModal = core.CloseCreateGallery();
    }}
    on:ModalClose={() => {
      core.openModal = core.CloseCreateGallery();
    }}
  />
{:else if core.openModal === 'add-to-gallery'}
  <AddToGallery
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
    on:AddedToGalleries={() => {
      core.openModal = core.Close();
    }}
  />
{:else if core.openModal === 'delete-post'}
  <DeletePostModal
    on:DeletePost={async () => {
      dispatch('ModalClose');
      await core.DeletePost();
    }}
    {post}
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
  />
{:else if core.openModal === 'donation-post'}
  <DonateModal
    on:Donate={e => {
      core.Donation(e);
      setPost();
    }}
    {post}
    on:ModalClose={() => {
      core.openModal = core.Close();
    }}
  />
{/if}

<div
  class="flex h-full overflow-hidden  rounded-2xl ml-10 items-center justify-stretch w-full"
>
  <section
    class="w-full bg-white border-grey-transparency-dark-8 rounded-l-[20px] lg:max-w-[40%] overflow-scroll scrollbar-hide {post
      ?.media[0]?.images.length !== 0
      ? 'rounded-tl-2xl'
      : 'rounded-2xl'} py-10 h-full"
    class:rounded-r-2xl={!media?.length}
    class:border={!disableBorder}
  >
    <div class="flex flex-col bg-white w-full">
      <!-- profile -->
      <div class="flex items-center justify-between px-3">
        <div class="flex items-center gap-5">
          <UserWrapper user={post?.creatorData} />
          <Collaborators collaborators={post.collaborators} isEditMode={false} />
        </div>
        <div class="font-switzer text-blueish-grey-600 text-sm pr-5">
          {dayjs(post.createdAt).fromNow()}
        </div>
      </div>
      <div class="flex flex-col gap-4 p-6">
        <!-- categories -->
        <div class="flex overflow-x-scroll mt-2 gap-x-2 scrollbar-hide">
          {#if post?.wasItem}
            <Tag label={'Classic'} rounded selectable={false} sm />
          {/if}
          {#each categories as category}
            {#if category}
              <Tag label={category} rounded selectable={false} sm />
            {/if}
          {/each}
        </div>
        <span
          class="text-2xl font-bold text-grey-transparency-dark border-none outline-none pt-1 break-words"
        >
          {title}
        </span>
        <span
          class="text-grey-transparency-dark-80 font-medium caret-brand-green border-none outline-none break-words"
        >
          {description}
        </span>
        {#if !preview}
          <span class="flex justify-between gap-2 pt-4">
            <div class="flex items-center gap-2">
              <Button
                disabled={!!!post?.creator}
                on:click={() => {
                  core.onDonate();
                  setPost();
                }}
                primary
                border={false}
                label="Donate"
              >
                <div slot="icon-right" class="-mr-1">
                  <div
                    class="px-1 text-xs border border-[#FFFFFF40] bg-[#FFFFFF1A] rounded-[3.75px] flex items-center"
                  >
                    {post.totalDonationsSeed || 0}
                  </div>
                </div>
              </Button>
              <Button
                disabled={!!!post?.creator}
                on:click={() => {
                  core.onAppreciate();
                  setPost();
                }}
                secondary
                icon
              >
                <span class="pr-2">
                  {post.likes?.length.toString()}
                </span>
                <div slot="icon-left" class="pl-2">
                  <PostHeart
                    class={post.likes?.includes($me?._id)
                      ? 'stroke-color-red-base'
                      : 'stroke-garden-grey-600'}
                    size={17}
                  />
                </div>
              </Button>
              <Button
                disabled={!!!post?.creator}
                on:click={() => {
                  core.onSave();
                  setPost();
                }}
                secondary
                icon
              >
                <span class="pr-1">{post?.savers?.length.toString() || '0'}</span>
                <div slot="icon-left" class="pl-1">
                  <PostFolder
                    color={post?.savers?.includes($me?._id) ? '#0F9D58' : '#47675B'}
                    size={17}
                  />
                </div>
              </Button>
            </div>
            <ThreeDotMenu
              {post}
              {threeDotIgnoredTargets}
              postCreator={post?.creator}
              on:CopyLink={() => {
                core.onCopyLink();
              }}
              on:DeletePost={async () => {
                dispatch('ModalClose');
                await core.DeletePost();
              }}
              on:ViewProfile={() => {
                dispatch('ModalClose');
                core.onViewProfile();
              }}
              on:EditPost={() => {
                dispatch('ModalClose');
                goto(`/post/edit/${post._id}`);
              }}
            />
          </span>
        {/if}
      </div>
      {#if $isMobile}
        <MobileImageCarousel2 hideButton={true} {media} />
      {/if}

      <UnderlinedTabs data={tabs} {activeTab} />
    </div>
  </section>
  {#if !$isMobile}
    {#if (post?.media[0]?.images.length !== 0 || post?.media[0].thumbnails.length !== 0) && media?.[0]}
      <section
        class=" 
        h-full border-grey-transparency-dark-8 rounded-r-2xl overflow-hidden  w-full"
        class:border={!disableBorder}
      >
        <div class="h-full w-full rounded-r-2xl bg-transparent">
          {#key srcImg}
            <TaggingOverlay
              bind:media
              bind:mediaIndex={selectedMediaIndex}
              bind:groupIndex
              {uploadable}
              owner={post.creator}
              tags={post?.tags}
            >
              <div class="flex w-full flex-1 h-full items-stretch overflow-x-scroll text-white scrollbar-hide">
                {#if preview}
                  <Media
                    class="h-full bg-transparent w-full object-contain flex-shrink-0 snap-center snap-mandatory"
                    src={srcImg}
                    controls={true}
                  />
                {:else}
                  <Media
                    class="h-full bg-transparent w-full object-contain flex-shrink-0 snap-center snap-mandatory"
                    src={srcImg}
                    controls={true}
                    lowResSrc={post?.media[selectedMediaIndex]?.thumbnails[groupIndex]}
                  />
                {/if}
              </div>
            </TaggingOverlay>
          {/key}
        </div>
      </section>
    {/if}
  {/if}
</div>

{#if media?.length >= 1}
  {#if !$isMobile}
    <div
      class="fixed -right-12 top-0 hover:right-0 hover:pr-6 h-full hover:w-4/12 flex flex-col justify-center items-end bg-gradient-to-l z-[2147483640] transition-all"
      class:hover:from-grey-neutral-20={!disableMediaSelectHoverBg}
      transition:fly|global={{ duration: 400, x: 200 }}
    >
      <ImageCarousel
        on:select={updateMediaProps}
        bind:media
        bind:mediaIndex={selectedMediaIndex}
        bind:groupIndex
        hideButton
      />
    </div>
  {/if}
{/if}
